import React from "react";
import { useOverrides } from "@quarkly/components";
import { Text, Em, LinkBox, Link, Box, Section } from "@quarkly/widgets";
const defaultProps = {
	"padding": "80px 0 30px 0",
	"background": "--color-dark",
	"quarkly-title": "Footer-18",
	"justify-content": "flex-start",
	"text-align": "left"
};
const overrides = {
	"box": {
		"kind": "Box",
		"props": {
			"display": "flex",
			"margin": "0px 0px 30px 0px",
			"md-margin": "0px 0px 45px 0px",
			"lg-flex-direction": "row",
			"lg-flex-wrap": "wrap",
			"lg-margin": "0px 0px 0 0px",
			"align-items": "flex-start",
			"flex-wrap": "wrap",
			"width": "100%"
		}
	},
	"linkBox": {
		"kind": "LinkBox",
		"props": {
			"lg-margin": "0px 0px 35px 0px",
			"lg-width": "40%",
			"sm-width": "100%",
			"href": "#",
			"width": "50%",
			"align-items": "flex-start"
		}
	},
	"text": {
		"kind": "Text",
		"props": {
			"margin": "0px 0px 0px 0px",
			"color": "--light",
			"font": "--headline2",
			"children": "Адреналин Арена"
		}
	},
	"box1": {
		"kind": "Box",
		"props": {
			"min-width": "100px",
			"min-height": "100px",
			"display": "flex",
			"grid-template-columns": "repeat(2, 1fr)",
			"grid-gap": "54px",
			"lg-align-items": "start",
			"md-grid-template-columns": "repeat(3, 1fr)",
			"md-grid-gap": "36px 34px",
			"sm-grid-template-columns": "1fr",
			"sm-grid-gap": "16px 0",
			"sm-flex-direction": "column",
			"lg-width": "60%",
			"sm-width": "100%",
			"sm-margin": "0px 0px 25px 0px",
			"lg-justify-content": "flex-end",
			"md-width": "100%",
			"md-justify-content": "flex-start",
			"sm-display": "flex",
			"width": "50%",
			"margin": "0px 0px 0px auto",
			"text-align": "right",
			"justify-content": "flex-end"
		}
	},
	"box2": {
		"kind": "Box",
		"props": {
			"align-items": "flex-start",
			"margin": "0px 0px 0px 0",
			"lg-align-items": "flex-start",
			"justify-content": "flex-start",
			"display": "grid",
			"lg-flex-direction": "column",
			"lg-margin": "0px 0px 0px 0px",
			"flex-direction": "column",
			"grid-gap": "10px 0",
			"align-content": "start",
			"sm-grid-gap": "16px"
		}
	},
	"link": {
		"kind": "Link",
		"props": {
			"border-color": "--color-primary",
			"display": "flex",
			"font": "normal 400 16px/24px --fontFamily-googleRoboto",
			"margin": "0px 0 0px 0",
			"lg-border-width": "0px 0px 0px 2px",
			"href": "/index",
			"text-decoration-line": "initial",
			"color": "#c3c8d0",
			"hover-color": "#ffffff",
			"letter-spacing": "1px",
			"children": "Главная"
		}
	},
	"link1": {
		"kind": "Link",
		"props": {
			"margin": "0px 0 0px 0",
			"display": "flex",
			"href": "/services",
			"font": "normal 400 16px/24px --fontFamily-googleRoboto",
			"text-decoration-line": "initial",
			"color": "#c3c8d0",
			"hover-color": "#ffffff",
			"letter-spacing": "1px",
			"children": "Услуги"
		}
	},
	"link2": {
		"kind": "Link",
		"props": {
			"margin": "0px 0 0px 0",
			"hover-color": "#ffffff",
			"href": "/contacts",
			"text-decoration-line": "initial",
			"color": "#c3c8d0",
			"font": "normal 400 16px/24px --fontFamily-googleRoboto",
			"display": "flex",
			"letter-spacing": "1px",
			"children": "Контакты"
		}
	},
	"box3": {
		"kind": "Box",
		"props": {
			"min-width": "100px",
			"min-height": "100px",
			"display": "flex",
			"lg-margin": "40px 0px 0 0px",
			"sm-flex-direction": "column",
			"sm-margin": "30px 0px 0 0px",
			"width": "100%"
		}
	},
	"box4": {
		"kind": "Box",
		"props": {
			"min-width": "100px",
			"min-height": "100px",
			"margin": "0px 30px 0px 0px",
			"lg-margin": "0px 50px 0px 0px",
			"display": "flex",
			"flex-direction": "column"
		}
	},
	"text1": {
		"kind": "Text",
		"props": {
			"margin": "0px 0px 25px 0px",
			"font": "normal 500 18px/1.2 --fontFamily-sans",
			"color": "--light",
			"md-margin": "0px 0px 20px 0px",
			"letter-spacing": "1px",
			"children": "Контакты"
		}
	},
	"link3": {
		"kind": "Link",
		"props": {
			"color": "#c3c8d0",
			"text-decoration-line": "initial",
			"font": "normal 300 16px/1.5 --fontFamily-sans",
			"display": "inline-block",
			"margin": "0px 0px 5px 0px",
			"white-space": "nowrap",
			"href": "tel:0965357576",
			"children": "+77766451010"
		}
	},
	"link4": {
		"kind": "Link",
		"props": {
			"color": "#c3c8d0",
			"text-decoration-line": "initial",
			"font": "normal 300 16px/1.5 --fontFamily-sans",
			"display": "inline-block",
			"margin": "0px 0px 15px 0px",
			"white-space": "nowrap",
			"href": "info@novarelilove.com",
			"children": "info@novarelilove.com"
		}
	},
	"box5": {
		"kind": "Box",
		"props": {
			"min-width": "100px",
			"min-height": "100px"
		}
	},
	"text2": {
		"kind": "Text",
		"props": {
			"margin": "0px 0px 25px 0px",
			"font": "normal 500 18px/1.2 --fontFamily-sans",
			"color": "--light",
			"md-margin": "0px 0px 20px 0px",
			"letter-spacing": "1px",
			"children": "Адрес"
		}
	},
	"text3": {
		"kind": "Text",
		"props": {
			"margin": "0px 0px 20px 0px",
			"color": "#c3c8d0",
			"font": "normal 300 16px/1.5 --fontFamily-sans",
			"border-color": "#b8acac",
			"md-margin": "0px 0px 15px 0px",
			"children": <>
				Ulitsa Gudermesskaya 67/1,{" "}
				<br />
				Karaganda 100000, Kazakhstan
			</>
		}
	},
	"box6": {
		"kind": "Box",
		"props": {
			"display": "flex",
			"justify-content": "space-between",
			"border-color": "#232a44",
			"md-flex-direction": "column",
			"lg-padding": "30px 0px 0px 0px",
			"md-padding": "0 0px 0px 0px"
		}
	},
	"text4": {
		"kind": "Text",
		"props": {
			"margin": "0px 0px 0px 0px",
			"font": "--base",
			"color": "#c3c8d0",
			"children": "© 2024 Адреналин Арена All rights reserved."
		}
	},
	"SectionContent": {
		"props": {
			"align-items": "flex-start"
		}
	}
};

const Footer = props => {
	const {
		override,
		children,
		rest
	} = useOverrides(props, overrides, defaultProps);
	return <Section {...rest}>
		<Box {...override("box")}>
			<LinkBox {...override("linkBox")}>
				<Text {...override("text")} />
			</LinkBox>
			<Box {...override("box1")}>
				<Box {...override("box2")}>
					<Link {...override("link")} />
					<Link {...override("link1")} />
					<Link {...override("link2")} />
				</Box>
			</Box>
			<Box {...override("box3")}>
				<Box {...override("box4")}>
					<Text {...override("text1")} />
					<Link {...override("link3")} />
					<Link {...override("link4")} />
				</Box>
				<Box {...override("box5")}>
					<Text {...override("text2")} />
					<Text {...override("text3")} />
				</Box>
			</Box>
		</Box>
		<Box {...override("box6")}>
			<Text {...override("text4")} />
		</Box>
		{children}
	</Section>;
};

Object.assign(Footer, { ...Section,
	defaultProps,
	overrides
});
export default Footer;